import * as ko from "knockout";
import {IKnockoutComponent, TBaseOrObservableOrFunctionType} from "../../index";
import {storeObservable} from "../../util/sessionstore";
import {copyToClipboard, getAnyValue, getNextId} from "../../util/misc";
import proxyHtml from './proxy.html?raw';

interface IOptions {
    component: TBaseOrObservableOrFunctionType<IKnockoutComponent>
}

export const template = proxyHtml

export class viewModel {
    /** Live target component — must track soft-nav / tab identity changes, not a constructor snapshot. */
    private readonly component: KnockoutComputed<IKnockoutComponent>;
    private readonly __id = getNextId()
    private readonly proxyName = '--component-proxy-' + this.__id
    private readonly showComponentName: KnockoutObservable<boolean> = storeObservable('show.component.name')
    private static readonly isActive: KnockoutObservable<viewModel | null> = ko.observable(null)
    private static timeoutId_toggleClick: number

    constructor(private options: IOptions) {
        this.component = ko.pureComputed(() => getAnyValue<IKnockoutComponent>(options.component))
    }

    private getTitle(): string {
        try {
            return JSON.stringify(getAnyValue(this.component()).params, null, 2)
        } catch(err) {
            return String(err)
        }
    }

    private isActive = ko.pureComputed(() => {
        return viewModel.isActive() == this
    })

    private onClick(vm: viewModel, e: JQuery.ClickEvent) {
        if (e.ctrlKey) {
            copyToClipboard(e.target.textContent)
            return false
        }
        clearTimeout(viewModel.timeoutId_toggleClick)
        viewModel.timeoutId_toggleClick = setTimeout(() => viewModel.isActive(null), 60 * 1000)
        viewModel.isActive(viewModel.isActive() === this ? null: this)
        e.preventDefault()
        e.stopPropagation()
        e.stopImmediatePropagation()
        return false
    }

    private getLabelStyle(): any {
        return {
            'position-anchor': this.proxyName,
        }
    }

    private getAnchorStyle(): any {
        return {
            'anchor-name': this.proxyName,
        }
    }

}